import React, { useState } from "react";
import styles from "../css/styles.module.css";
import { app } from "../config/firebase.js";
import loadingIcon from "../images/loading.gif";

export default function Login(props) {
  //setting up all the states
  const [email, setEmail] = useState(() => "");
  const [password, setPassword] = useState(() => "");
  const [error, setError] = useState(() => false);
  const [loading, setLoading] = useState(false);

  //handles value change from the email input box
  function handleEmailChange(e) {
    e.persist(); //needed to make sure that event prop does not become undefine
    setEmail(e.target.value); //get the value from the input text box
  }

  //handles value change from the password input box
  function handlePasswordChange(e) {
    e.persist();
    setPassword(e.target.value);
  }

  //handles form submit event
  function handleSubmit(e) {
    e.preventDefault(); //prevent page from reloading due to form submitting
    setLoading(true);
    setError(false);
    app
      .auth()
      .signInWithEmailAndPassword(email, password) // firebase authentication base on email and password state
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setPassword("");
        //displaying error messages base on error code
        if (
          err.code === "auth/user-not-found" ||
          err.code === "auth/wrong-password"
        ) {
          setLoading(false);
          setError(true);
        }
      });
  }

  return (
    <div className={styles.loginContainer}>
      <div className={styles.form}>
        <form onSubmit={handleSubmit}>
          <div className={styles.logo}>
            <h1 className={styles.highlight}>SDM</h1>
            <h1>Sales Report</h1>
          </div>
          <input
            type="email"
            placeholder="Username"
            onChange={handleEmailChange}
            value={email}
            required
          ></input>
          <input
            type="password"
            placeholder="Password"
            onChange={handlePasswordChange}
            value={password}
            required
          ></input>
          <button type="submit">Login</button>
          {error && <p className={styles.error}>Incorrect email or password</p>}
          {loading && <div className={styles.loadingContainer}><img src={loadingIcon} className={styles.loadingIcon} alt="loading"/></div>}
        </form>
      </div>
    </div>
  );
}
